import { enableProdMode, APP_INITIALIZER, LOCALE_ID, ErrorHandler, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { KeycloakService } from './app/core/auth/keycloak.service';
import { GlobalErrorHandler } from './app/core/services/error-handler.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from './app/core/core.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app/app.component';

function initializeKeycloak(keycloakService: KeycloakService): () => Promise<boolean> {
    return () => keycloakService.initKeycloak();
}



if (environment.production) {
    enableProdMode();
    // Production builds must not print anything to the browser console: error
    // objects carry request URLs, headers and server messages. Real faults are
    // reported server-side (request id on every API error).
    const noop = () => undefined;
    for (const m of ['log', 'debug', 'info', 'warn', 'error', 'trace', 'table', 'dir'] as const) {
        (console as unknown as Record<string, unknown>)[m] = noop;
    }
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withXsrfConfiguration({
                cookieName: 'XSRF-TOKEN',
                headerName: 'X-CSRF-Token',
            })
        ),
        importProvidersFrom(
            AppRoutingModule,
            CoreModule,
            NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
        ),
        // NgRx
        importProvidersFrom(StoreModule.forRoot({}, {
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictActionSerializability: false,
                strictStateSerializability: false,
            },
        }), EffectsModule.forRoot([]), StoreRouterConnectingModule.forRoot(), ...(!environment.production
            ? [StoreDevtoolsModule.instrument({ maxAge: 25 })]
            : [])),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            deps: [KeycloakService],
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        }]
})
    .catch((err: unknown) => console.error(err));